import { Link } from 'react-router-dom'
import { useHomeDashboard } from '@/api/queries'
import { StatusChip } from '@/components/ui/status-chip'
import type { WidgetSpan } from '../Widget'
import { Widget } from '../Widget'

function meterClass(pct: number) {
  return pct >= 85 ? 'bg-ok' : pct >= 65 ? 'bg-warn' : 'bg-critical'
}

export function SecurityRollupWidget({ span = 6 }: { span?: WidgetSpan }) {
  const { data, isLoading } = useHomeDashboard()

  return (
    <Widget
      title="Security posture rollup"
      badges={<StatusChip status="info">M12</StatusChip>}
      provenance={data?.provenance.security}
      span={span}
      footer={
        <Link to="/security" className="font-semibold text-accent hover:underline">
          Open Security Center →
        </Link>
      }
    >
      {isLoading || !data ? (
        <div className="text-[12.5px] text-ink-2">Loading…</div>
      ) : (
        <>
          {data.security.map((cat) => (
            <div key={cat.name} className="flex items-center gap-2.5 py-1.5">
              <div className="w-[220px] text-[12.5px]">{cat.name}</div>
              <div className="h-[7px] flex-1 overflow-hidden rounded-full bg-border">
                <div className={`h-full ${meterClass(cat.pct)}`} style={{ width: `${cat.pct}%` }} />
              </div>
              <div className="mono w-9 text-right text-[12px]">{cat.pct}</div>
            </div>
          ))}
          <div className="mt-2 text-[11px] text-ink-2">
            Real ratios composed from the security governance store (rotations · vuln SLA · observability coverage). CVE
            findings are operator-reported — no live scanner feed is wired in R1 (FR-SEC-05).
          </div>
        </>
      )}
    </Widget>
  )
}
